import React from "react";

/**
 * Works out correct plural depending on quanity
 *
 * @param int num
 * @param string singular
 * @param string plural
 */
export const pluralise = (num, singular, plural) => {
  if (num > 1) {
    return plural;
  }

  return singular;
};

/**
 * Return object key by value
 *
 * @param object object
 * @param mixed value
 */
export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

/**
 * Clones object
 *
 * @param object object
 */
export const cloneObject = (object) => JSON.parse(JSON.stringify(object));

/**
 * Returns an array of dates between the two dates
 *
 * @dep dayjs
 */
export const getDateTimeRange = (
  start,
  end,
  increment = "1",
  amount = "day"
) => {
  const dates = [];

  while (start < end) {
    dates.push(start.format("YYYY-MM-DD"));
    start = start.add(increment, amount);
  }

  return dates;
};

export const numRange = (min, max, step) => {
  const len = Math.floor((max - min) / step) + 1;
  return Array(len)
    .fill()
    .map((_, idx) => min + idx * step);
};

export const iOS = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

export const usePopState = () => {
  const pathname = window.location.pathname;
  const segment = pathname.substring(pathname.lastIndexOf("/") + 1);

  const [path, setPath] = React.useState(window.location.pathname);

  const listenToPopstate = () => {
    const winPath = window.location.pathname;
    setPath(segment);
  };

  React.useEffect(() => {
    window.addEventListener("popstate", listenToPopstate);
    return () => {
      window.removeEventListener("popstate", listenToPopstate);
    };
  }, []);

  return path;
};

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

export const zeroPad = (num, places) => String(num).padStart(places, "0");

export const buildUrlParams = (params) => {
  var parts = [];
  if (typeof params === "object") {
    for (const param in params) {
      if (params[param]) {
        parts.push(`${param}=${encodeURIComponent(params[param])}`);
      }
    }
  }

  return parts.join("&");
};

export const absFloat = (float) =>
  !isNaN(parseFloat(float)) ? parseFloat(float) : 0;

export const arraySum = (array, initialValue = 0) =>
  array.reduce(
    (accumulator, currentValue) =>
      absFloat(accumulator) + absFloat(currentValue),
    initialValue
  );

export const emptyString = (string) =>
  typeof string !== "string" || !string || !string.trim().length;

export const randomFloat = (min, max) => {
  return Math.random() * (max - min) + min;
};
